import { Component, OnInit } from '@angular/core';
import { LoginService } from 'src/app/services/security/login.service';

@Component({
  selector: 'neoris-minidashboard',
  templateUrl: './minidashboard.component.html',
  styleUrls: ['./minidashboard.component.css']
})
export class MinidashboardComponent implements OnInit {

  siteId:string
  constructor(private securityService: LoginService) { }

  async ngOnInit(): Promise<void> {
    
const userName = JSON.parse(localStorage.getItem('ud'))[1].value
const guid = JSON.parse(localStorage.getItem('guidSession'))
const response = await this.securityService.login(userName,guid).toPromise()

    this.siteId = localStorage.getItem('site')
  }

}
